module.exports = __webpack_public_path__ + "static/media/undraw_dev_focus_b9xo.7442ff10.svg";